/**
 * A integração de ENTRADA: o sistema de folha do cliente empurrando admissões e demissões.
 *
 * Não confundir com `integrationCredentials.ts`, que é o contrário — as credenciais com que
 * este sistema chama fornecedores (Sankhya, Ponto Icarus) em nome da empresa.
 *
 * Os ids são `string` porque as colunas são BIGINT e o driver devolve texto; tratá-los como
 * número aqui reintroduziria a comparação que falha em silêncio.
 */

export interface PayrollConnection {
  id: string;
  name: string;
  provider: string;
  keyPrefix: string;
  active: boolean;
  createMissingStructure: boolean;
  lastUsedAt: string | null;
  createdAt?: string;
}

/** A resposta da criação — a única vez em que a chave existe em claro. */
export interface PayrollConnectionCreated {
  connection: PayrollConnection;
  chave: string;
}

export interface PayrollConnectionInput {
  name: string;
  provider?: string;
  createMissingStructure?: boolean;
}

export interface PayrollConnectionUpdate {
  name?: string;
  provider?: string;
  createMissingStructure?: boolean;
  active?: boolean;
}

export interface PayrollSyncRun {
  id: string;
  connectionId: string;
  startedAt: string;
  finishedAt: string | null;
  received: number;
  created: number;
  updated: number;
  unchanged: number;
  rejected: number;
  errorSummary: string | null;
  requestIp: string | null;
}

export interface PayrollSyncRunPage {
  runs: PayrollSyncRun[];
  total: number;
}

/**
 * Os sistemas de folha que o cliente reconhece pelo nome. O valor é rótulo de auditoria, não
 * muda o contrato — todos falam a mesma rota, com o mesmo formato.
 */
export const PAYROLL_PROVIDERS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'generico', label: 'Outro / Genérico' },
  { value: 'senior', label: 'Senior' },
  { value: 'totvs', label: 'TOTVS (Protheus / RM)' },
  { value: 'sankhya', label: 'Sankhya' },
];
